import styled from 'styled-components';
import { Link, Button, mq } from '@phishtool/ui';
export const StyledTopBarWrapper = styled.div.withConfig({ displayName: "StyledTopBarWrapper", componentId: "-s5ay5n" }) `
  background-color: ${(props) => props.theme.colors.darkEclipse};

  ${mq({
    display: ['none', null, 'block'],
})}
`;
export const StyledTopBarLinkWrapper = styled.div.withConfig({ displayName: "StyledTopBarLinkWrapper", componentId: "-1l8dsbx" }) `
  display: flex;
  gap: ${(props) => props.theme.spacers.large};
  justify-content: flex-end;
  align-items: center;
  height: 40px;
`;
export const StyledTopBarLink = styled.a.withConfig({ displayName: "StyledTopBarLink", componentId: "-2b0t9o" }) `
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.white};
  text-decoration: none;
  font-size: 12px;
  font-weight: 500;
  gap: ${(props) => props.theme.spacers.small};

  &:hover {
    color: ${(props) => props.theme.colors.littleBoyBlue};
    * {
      fill: ${(props) => props.theme.colors.littleBoyBlue};
    }
  }
`;
export const StyledMainHeaderWrapper = styled.div.withConfig({ displayName: "StyledMainHeaderWrapper", componentId: "-174vj8x" }) `
  background-color: ${(props) => props.theme.colors.spaceCadet};
  position: relative;
`;
export const StyledLogoWrapper = styled.div.withConfig({ displayName: "StyledLogoWrapper", componentId: "-1wu6drj" }) `
  height: 100%;
  display: flex;
  align-items: center;
`;
export const StyledBannerWrapper = styled.div.withConfig({ displayName: "StyledBannerWrapper", componentId: "-5q1xlq" }) `
  background-color: ${(props) => props.theme.colors.white};
  box-shadow: ${(props) => props.theme.shadows.primary};
  padding: ${(props) => props.theme.spacers.medium} 0;
`;
export const StyledBannerText = styled.p.withConfig({ displayName: "StyledBannerText", componentId: "-6v4nfh" }) `
  color: ${(props) => props.theme.colors.blackCoral};
  font-size: 14px;
  text-align: center;
  margin: 0;
`;
export const StyledBannerLink = styled(Link).withConfig({ displayName: "StyledBannerLink", componentId: "-aujga7" }) `
  font-weight: 500;

  &:hover {
    font-weight: 500;
  }
`;
export const StyledStickyHeader = styled.div.withConfig({ displayName: "StyledStickyHeader", componentId: "-to5y43" }) `
  position: sticky;
  top: 0;
  z-index: 2;
`;
export const StyledMainHeaderNavigationWrapper = styled.div.withConfig({ displayName: "StyledMainHeaderNavigationWrapper", componentId: "-lixbgd" }) `
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${(props) => props.theme.spacers.medium};

  ${mq({
    height: ['55px', null, 'auto'],
})}
`;
export const StyledDemoButton = styled(Button).withConfig({ displayName: "StyledDemoButton", componentId: "-13bz0vw" }) `
  ${mq({
    display: ['none', null, 'inline-flex'],
})}
`;
export const StyledCookieBannerWrapper = styled.div.withConfig({ displayName: "StyledCookieBannerWrapper", componentId: "-16c9mtx" }) `
  background-color: ${(props) => props.theme.colors.darkEclipse};
  padding: ${(props) => props.theme.spacers.medium} 0;

  p {
    color: ${(props) => props.theme.colors.white};
    font-size: 14px;
    margin: 0;
  }
`;
export const StyledCookieButton = styled(Button).withConfig({ displayName: "StyledCookieButton", componentId: "-1uzgn2b" }) `
  min-width: 78px;
  height: 20px;
  font-size: 12px;
`;
